export class EditProductStatusDto {
    productStatusTypeId: string;
    suspensionReasonId: string;
    prospectReasonId: string;
}